<template>
  <div class="row">
    <div class="col-lg-4 col-md-5">
      <user-card>

      </user-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <edit-profile-form>

      </edit-profile-form>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from '@/components/User/UserProfile/EditProfileForm.vue'
  import UserCard from '@/components/User/UserProfile/UserCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Company/User/Profile.vue